import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ShopingBagView from '../../../containers/MarketPlace/ShopingBag/ShopingBag';
import ShopingBagPoins from '../../../containers/MarketPlace/ShopingBag/ShopingBagPoins';


const ShoppingBagPoins = () => {
    const { bagPoints } = useSelector(state => state.marketPlace)

   
   return <ShopingBagPoins bag={bagPoints}/>
}

export default ShoppingBagPoins
